import Vue from 'vue';
import Router from 'vue-router';
import authenticate from './system/auth/authenticate';
import config from './system/request/config';

Vue.use(Router);

// hash mode: the coin domain needs no server-side catch-all route
const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    { path: '/', redirect: '/wallet' },
    { path: '/wallet', name: 'wallet', component: () => import('./views/wallet.vue'), meta: { nav: 'wallet', title: 'WALLETS' } },
    ...(config.showRelease ? [{ path: '/release', name: 'release', component: () => import('./views/release.vue'), meta: { nav: 'release', title: 'YIELD' } }] : []),
    ...(config.showTeam ? [{ path: '/team', name: 'team', component: () => import('./views/team.vue'), meta: { nav: 'team', title: 'TEAM' } }] : []),
    { path: '/withdraw', name: 'withdraw', component: () => import('./views/withdraw.vue'), meta: { nav: 'withdraw', title: 'WITHDRAW' } },
    { path: '/records/:type', name: 'records', component: () => import('./views/records.vue'), meta: { nav: 'records', title: 'RECORDS' } },
    { path: '*', redirect: '/wallet' },
  ],
});

router.beforeEach(authenticate);

export default router;
